/**
 * TanStack Query hooks for the mobile attribution vendor postback template
 * feature. Thin wrappers over ./api — UI copy stays vendor-neutral.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	mmpPostbackTemplateQueryKeys,
	type CreateMmpPostbackTemplateBody,
	type CreateMmpPostbackTemplateResponse,
	type ListMmpPostbackTemplateResponse,
} from "./api";

export function useMmpPostbackTemplateList(): UseQueryResult<
	ListMmpPostbackTemplateResponse,
	Error
> {
	return useQuery({
		queryKey: mmpPostbackTemplateQueryKeys.list(),
		queryFn: list,
	});
}

export function useMmpPostbackTemplateCreate(): UseMutationResult<
	CreateMmpPostbackTemplateResponse,
	Error,
	CreateMmpPostbackTemplateBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: mmpPostbackTemplateQueryKeys.all });
		},
	});
}

export function useMmpPostbackTemplateDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: mmpPostbackTemplateQueryKeys.all });
		},
	});
}
